export default __webpack_public_path__ + "static/B38-2c6a7e561412944008496556ed4fbb47.png";